import React from 'react';
import { IdCard, Mail, Smartphone } from 'lucide-react';
import { badgesOf } from '@/utils/verifications';

const BADGES = [
  { kind: 'email', label: 'E-mail vérifié', short: 'E-mail', Icon: Mail },
  { kind: 'phone', label: 'Téléphone vérifié', short: 'Téléphone', Icon: Smartphone },
  { kind: 'identity', label: 'Identité vérifiée', short: 'Identité', Icon: IdCard },
];

/**
 * Coches de vérification d'un autre membre (décision du 2026-10-17 : une coche par vérification, à la place de
 * l'unique « vérifié »). `compact` : icônes seules, le libellé en infobulle. Rien n'est affiché si rien n'est vérifié.
 */
export default function VerificationBadges({ user, compact = false }) {
  const badges = badgesOf(user);
  const shown = BADGES.filter((b) => badges[b.kind]);
  if (shown.length === 0) return null;
  return (
    <span className="verif-badges" data-testid="verification-badges" style={{ display: 'inline-flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
      {shown.map(({ kind, label, short, Icon }) => (
        <span key={kind} title={label} aria-label={label} data-testid={`badge-${kind}`}
          style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: 11, fontWeight: 600, color: 'var(--teal, #0E7C6B)' }}>
          <Icon size={12} aria-hidden="true" />{!compact && <>{short} ✓</>}
        </span>
      ))}
    </span>
  );
}
